import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, ORDER_URL } from "@/data/menu";

export const Header = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-brand-border bg-brand-bg/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:h-20 lg:px-8">
        <a
          href="#home"
          data-testid="nav-logo"
          className="font-serif text-lg font-semibold tracking-wide text-brand-dark md:text-xl"
        >
          B<span className="font-sans text-[0.85em]">1</span>{" "}
          <span className="text-brand-accent">&amp;</span> B
          <span className="font-sans text-[0.85em]">2</span>{" "}
          <span className="text-xs font-light tracking-[0.3em] text-brand-gray md:text-sm">
            CATERING
          </span>
        </a>

        <nav aria-label="Основна навигация" className="hidden items-center gap-7 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="whitespace-nowrap text-sm font-medium text-brand-gray transition-colors hover:text-brand-accent"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-header-order"
            className="hidden items-center gap-1.5 rounded-full bg-brand-accent px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-accentHover active:scale-[0.98] sm:inline-flex lg:ml-5"
          >
            Заявете към „Българче“
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
          <button
            type="button"
            data-testid="nav-menu-button"
            aria-expanded={open}
            aria-label={open ? "Затвори менюто" : "Отвори менюто"}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-border text-brand-dark lg:hidden"
          >
            {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="Мобилна навигация"
          data-testid="mobile-menu"
          data-lenis-prevent
          className="max-h-[calc(100svh-4rem)] overflow-y-auto overscroll-contain border-t border-brand-border bg-brand-bg px-6 pb-6 pt-3 lg:hidden"
        >
          <ul className="flex flex-col divide-y divide-brand-border">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => setOpen(false)}
                  className="block py-3.5 text-base font-medium text-brand-dark"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-mobile-order"
            className="mt-4 flex items-center justify-center gap-1.5 rounded-full bg-brand-accent px-5 py-3.5 text-sm font-semibold text-white"
          >
            Заявете към „Българче“
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
        </nav>
      )}
    </header>
  );
};
